import { lazyWithRetry } from "@circle-react/helpers/lazyRetry";
import { Suspense } from "react";

import {
  ModalManager,
  useModal,
} from "@/react/components/Layout/ModalManagerProvider";

import type { ManagedPartnerOnboardingModalProps } from "./types";

const PartnerOnboardingModal = lazyWithRetry(() =>
  import(/* webpackChunkName: "PartnerOnboardingModal" */ "./index").then(
    module => ({ default: module.PartnerOnboardingModal }),
  ),
);

export const ManagedPartnerOnboardingModal = ModalManager.create(
  ({ onComplete }: ManagedPartnerOnboardingModalProps) => {
    const modal = useModal();

    return (
      <Suspense fallback={null}>
        <PartnerOnboardingModal
          open={modal.visible}
          onOpenChange={open => {
            if (!open) void modal.hide();
          }}
          onComplete={() => {
            void modal.hide();
            onComplete();
          }}
        />
      </Suspense>
    );
  },
);
